import React from "react";
import { Col, Input, InputGroup, InputGroupText, Row } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";

import {
  ModalProps,
  serviceCaller,
  ServiceCallerProps,
} from "../../composition";
import Fragment from "../../../toolkit/fragment";
import DatePicker from "react-datepicker";
import datePickerS from "react-datepicker/dist/react-datepicker.css";
import moment, { Moment } from "moment-timezone";
import { isCurrentUserCollaborator } from "../../../utils/roleCheck";
import s from "./styles.scss";

interface Props extends ServiceCallerProps, ModalProps {
  colSize: number;

  canEditPublishing: boolean;
  busyLoading: boolean;
  scheduleDate?: Moment;
  validateTime: boolean;
  enableTimeRestriction: boolean;

  updateScheduleDate: (scheduleDate: Moment) => void;
  updateScheduleChecked: (checked: boolean) => void;
}

interface State {
  timeError: boolean;
  timeErrorValue: string;
  time: number;
}

class ScheduleSection extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      //   validateTime: true,
      timeError: false,
      timeErrorValue:
        "There is a conflict between the scheduled time and the publishing restriction. Please, change it",
      time: 0,
    };
  }

  validateTimeChanged = event => {
    const checked = event.target.checked;
    /*this.setState({
      //  validateTime: checked,
      timeError: false,
    }, () => { */
    this.props.updateScheduleChecked(checked);
    // });
    //todo : call handler
  };

  onDateChange = e => {
    //todo: call handler

    if (e) {
      let today = moment();
      if (today.isSameOrBefore(e, "day")) {
        this.props.updateScheduleDate(e);
        this.setState({
          // scheduleDate: e,
          timeError: false,
        });
      }
    } else {
      this.props.updateScheduleDate(undefined);
      this.setState({
        // scheduleDate: undefined,
        timeError: false,
      });
    }
  };

  render() {
    const {
      busyLoading,
      canEditPublishing,
      colSize,
      scheduleDate,
      validateTime,
      enableTimeRestriction,
    } = this.props;

    const htmlId = "validateTime" + (validateTime ? "_checked" : "_unchecked");
    return (
      <Col sm={colSize}>
        <label className={s.titleLabel} htmlFor="date">
          Schedule
        </label>
        <Row className={s.validationBox}>
          <Col className={s.choice} sm={"12"}>
            {enableTimeRestriction && (
              <Fragment>
                <Input
                  type="checkbox"
                  id={htmlId}
                  checked={validateTime}
                  onChange={this.validateTimeChanged}
                  disabled={
                    !canEditPublishing ||
                    !isCurrentUserCollaborator(this.props.currentCharity)
                  }
                />
                <label htmlFor={htmlId} />
                <span className={s.label}>
                  {"Deliver from 8:00 am to 6:00 pm PST"}
                </span>
              </Fragment>
            )}
          </Col>
        </Row>
        <InputGroup>
          <InputGroupText className={s.inputGroup}>
            <i className={"fa fa-calendar " + s.calendarIcon}>&nbsp;</i>
          </InputGroupText>
          <div className={s.datePicker}>
            <DatePicker
              disabled={
                !canEditPublishing ||
                busyLoading !== null ||
                !isCurrentUserCollaborator(this.props.currentCharity)
              }
              id="date"
              showTimeSelect
              className={s.text}
              selected={scheduleDate}
              timeFormat="HH:mm"
              timeIntervals={10}
              dateFormat="LLL"
              timeCaption="Time"
              placeholderText="Now"
              onChange={this.onDateChange}
              autoComplete="off"
            />
          </div>
        </InputGroup>
      </Col>
    );
  }
}

export default serviceCaller(withStyles(datePickerS, s)(ScheduleSection));
